module.exports = __webpack_public_path__ + "images/emoji/notebook_with_decorative_cover.faf9ff0927dc46940142.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/notebook_with_decorative_cover.png
// module id = S3N/
// module chunks = 14